'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

export function useTrackPrevPath() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const qs = searchParams?.toString() ?? '';
  const firstLoad = useRef(true);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const current = qs ? `${pathname}?${qs}` : pathname;
    const prev = sessionStorage.getItem('current_path');

    if (!firstLoad.current) {
      if (prev) sessionStorage.setItem('prev_path', prev);
      sessionStorage.setItem('current_path', current);
    } else {
      sessionStorage.setItem('current_path', current);
      firstLoad.current = false;
    }
  }, [pathname, qs]);
}
